import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 20,
        fontStyle: 'bold',
    },
    description: {
        width: '35%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 8,
        fontSize: 8
    },
    poNumber: {
        width: '30%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center'
    },
    caseid: {
      width: '25%',
      borderRightColor: borderColor,
      borderRightWidth: 1,
      textAlign: 'left',
      paddingLeft: 5,
    },

    unitPrice: {
        width: '17.5%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 4,
    },
    qty: {
        width: '10%',
        textAlign: 'right',
        paddingRight: 4,
    },
  });


const PackageCaseRow = ({cases}) => {
  const numberWithCommas = (x) => {

      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  const rows = cases.map( item => {
      let surg_info = item.Surgeon
      let patient_info = item.Patient



      return(
        <View style={styles.row} key={item.case_id}>
          <Text style={styles.caseid}>{item.case_id}</Text>

          <Text style={styles.description}>
          Knee Guide, Dr. {surg_info.First_Name} {surg_info.Last_Name}
         {'\n'}
          {/*Patient {patient_info.First_Name} {patient_info.Last_Name}*/}
          </Text>
          <Text style={styles.poNumber}> {item.PO_number}
          </Text>
          <Text style={styles.qty}>1</Text>

        </View>
      )

    }

  )


    return (
    <Fragment>
      {rows}
    </Fragment>
    )
};

export default PackageCaseRow;
